module.exports = __webpack_public_path__ + "img/bcas-light.15284a58.png";